// Shared Task Type definitions (label + pill color)
export const TASK_TYPES = [
  "Phone Call",
  "Email",
  "Meeting",
  "Site Visit",
  "Quote",
  "Admin",
  "Other",
];

// Map each type to a pill class defined in the existing global styles.
// Falls back to "pill-grey" for any unknown value.
const TYPE_CLASS = {
  "Phone Call": "pill-blue",
  "Email":      "pill-purple",
  "Meeting":    "pill-green",
  "Site Visit": "pill-orange",
  "Quote":      "pill-yellow",
  "Admin":      "pill-grey",
  "Other":      "pill-grey",
};

export function taskTypePillClass(type) {
  return TYPE_CLASS[type] || "pill-grey";
}
